import { useNavigate, useParams } from "react-router-dom";
import { DeviceListContainer } from "../../style/contents/backup/backup";
import { DeviceItem } from "../../view/contents/backup/backup.device.list";

interface Props {
  data: DeviceItem[];
  selectedDevices: string[];
  onSelectChange: (deviceId: string, checked: boolean) => void;
  role: string;
  department?: string;
  folderPathPrefix?: string;
}

const DeviceList = ({
  data,
  onSelectChange,
  selectedDevices,
  role,
  department,
  folderPathPrefix = "/backup/folder",
}: Props) => {
  const { id } = useParams<{ id: string }>();

  console.log("device list :", data);

  const navigate = useNavigate();
  const viewBackupBtn = (
    deviceId: string,
    userAccount: string,
    userName: string,
    department: string,
    pcName: string,
    isAdmin: boolean,
  ) => {
    const encodedDeviceId = encodeURIComponent(deviceId);
    const encodedName = btoa(encodeURIComponent(userName)); // 이름 인코딩
    const encodedDept = btoa(encodeURIComponent(department)); // 부서 인코딩
    const encodedPcName = btoa(encodeURIComponent(pcName)); // PC 이름 인코딩

    navigate(
      `${folderPathPrefix}/${encodedDeviceId}?id=${id}&userAccount=${userAccount}&name=${encodedName}&department=${encodedDept}&pcName=${encodedPcName}&isAdmin=${isAdmin}`,
    );
  };

  return (
    <DeviceListContainer>
      {data.map((item, index) => {
        const isChecked = selectedDevices.includes(item.deviceId);

        return (
          <div className="device-items" key={index}>
            <div className="device-item">
              <div className="input-box">
                {role === "admin" && (
                  <input
                    type="checkbox"
                    id={`device-${index}`}
                    checked={isChecked}
                    onChange={(e) =>
                      onSelectChange(item.deviceId, e.target.checked)
                    }
                  />
                )}
                <label htmlFor={`device-${index}`}>{item.pcName}</label>
              </div>

              <div className="view-backup">
                <button
                  onClick={() =>
                    viewBackupBtn(
                      item.deviceId,
                      item.userAccount,
                      item.userName || "미입력",
                      department || "-",
                      item.pcName || "미입력",
                      role === "admin",
                    )
                  }
                >
                  백업 보기
                </button>
              </div>
            </div>
            <div className="info">
              <div className="device-info">
                {role === "admin" && <p>IP : {item.originIp}</p>}
                <p>MAC Address : {item.deviceId}</p>
              </div>
              <div className="user-info">
                <span>아이디: {item.userAccount}</span>
                <span>|</span>
                <span>부서: {department}</span>
                <span>|</span>
                <span>이름: {item.userName ? item.userName : "미입력"}</span>
              </div>
            </div>
          </div>
        );
      })}
    </DeviceListContainer>
  );
};

export default DeviceList;
